import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";

import "./EventDetailFacts.scss";
import { EventDate } from '../../parts/EventDate/EventDate';

const hasValue = value=>value !== undefined && value !== null && value !== "" && value !== false;

export const EventDetailFacts = (props)=>{
    const { event, detail } = props;
    const { labels } = detail;
    const rows = [
        { label:labels.startAt, value:event.startAtEst && <EventDate value={event.startAtEst} row={event}/>, icon:EventOutlinedIcon },
        { label:labels.duration, value:detail.duration, icon:HourglassEmptyOutlinedIcon },
        { label:labels.address, value:event.gameSpace?.address, icon:PlaceOutlinedIcon },
        { label:labels.id, value:event.id, icon:KeyOutlinedIcon },
        { label:labels.publishedAt, value:detail.publishedAt, icon:PublishOutlinedIcon }
    ];

    return (
        <Block tagName="section" className="EventDetailFacts wall -form">
            <div className="header"><Caption>{labels.details}</Caption></div>
            <ul className="iconized">
                {rows.filter(row=>hasValue(row.value)).map(row=>{
                    const Icon = row.icon;
                    return (
                        <li key={row.label}>
                            <Icon fontSize="small"/>
                            <p className="fieldLabel">{row.label}</p>
                            <div className="fieldValue">{row.value}</div>
                        </li>
                    );
                })}
            </ul>
        </Block>
    )
}
